export default __webpack_public_path__ + "static/media/different-classes.e8b04cfc.svg";